import React from 'react'
import { PropTypes } from 'prop-types'

import FeedEmojis from './FeedEmojis'
import FeedLikes from './FeedLikes'

import './styles.scss'
const bc = 'feed-reactions'

const FeedReactions = ({ setReaction, reactions, hasReacted, likeActionEnabled }) => {
  const usersReactions = reactions || []
  const likesCount = usersReactions.length
  const emojis = usersReactions.reduce((result, reaction) => {
    result[reaction.emoji] = true
    return result
  }, {})
  const users = usersReactions.map(item => item.user)

  return (
    <div className={bc}>
      {likeActionEnabled ? <FeedEmojis setReaction={setReaction} hasReacted={hasReacted} /> : <div />}
      {likesCount > 0 && <FeedLikes emojis={Object.keys(emojis)} users={users} likesCount={likesCount} />}
    </div>
  )
}

FeedReactions.propTypes = {
  setReaction: PropTypes.func.isRequired,
  reactions: PropTypes.array,
  hasReacted: PropTypes.bool,
  likeActionEnabled: PropTypes.bool,
}

export default FeedReactions
